import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import PDCCreate from "./PumpDC/Create";
import MDCCreate from "./ManufacturingDC/Create";

function DcCreate() {
  const [deliveryChallanType, setDeliveryChallanType] = useState("");
  const [deliveryChallanCategory, setDeliveryChallanCategory] = useState("");
  const [typeDisabled, setTypeDisabled] = useState(false);

  const handleDeliveryChallanTypeChange = (e) => {
    const selectedType = e.target.value;
    setDeliveryChallanType(selectedType);
    // Category always "Domestic"
    setDeliveryChallanCategory("Domestic");
    setTypeDisabled(true);
  };

  const PageDisplay = () => {
    if (deliveryChallanType === "Pump Spare" && deliveryChallanCategory === "Domestic") {
      return <PDCCreate />;
    } else if (deliveryChallanType === "Manufacturing" && deliveryChallanCategory === "Domestic") {
      return <MDCCreate />;
    }
    return null;
  };

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD DELIVERY CHALLAN</h6>
          <Link to="/dcindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Product Type:</Form.Label>
                <Form.Select
                  onChange={handleDeliveryChallanTypeChange}
                  value={deliveryChallanType}
                  disabled={typeDisabled}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {deliveryChallanType && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>Product Category:</Form.Label>
                  <Form.Control value="Domestic" disabled />
                </Form.Group>
              </Col>
            )}

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
  );
}

export default DcCreate;
